// extracted by mini-css-extract-plugin
export default {"buyButton":"Pg_1_12_buyButton__iYqkK","right":"Pg_1_12_right__M64Dt"};